
export class Country {
  readonly name: string;
  readonly code: string;
}
